module.exports = __webpack_public_path__ + "img/8.6c108f4a.jpg";